import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../../constants/environment';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import { InvoiceDetailResponse } from './useGetInvoiceDetail';

export interface UpdateInvoiceInput {
    invoiceId: string;
    updatedFields?: Partial<InvoiceDetailResponse>;
    /** Revert a line-item structure correction (expand/consolidate) by part number */
    revertLineItemCorrection?: { partNumber: string; };
    /** Re-fetch NEX data for the RO and re-run reconciliation (suggested matches in Flagged Item modal). */
    refreshNexsyisData?: boolean;
    /** Both-mode orgs: PO-first cascade vs RO-only refresh from Key Identifiers. */
    refreshNexsyisStrategy?: 'po_first' | 'ro_only';
    /** When true, set invoice status to manually_submitted (user clicked Submit on detail page). */
    markAsManuallySubmitted?: boolean;
    /** Submit-only: global apDist line index -> NEX poHeaderID for manual orphan rows. Not persisted. */
    manualPoHeaderOverrides?: Record<string, number>;
}

const updateInvoice = async (updateInvoiceInput: UpdateInvoiceInput, sessionId: string | null) => {
    return axios.post(`${API_URL}/invoice/update`,
        updateInvoiceInput,
        {
            headers: {
                Authorization: sessionId
            }
        }
    );
};

export const useUpdateInvoice = (options?: UseMutationOptions<any, any, UpdateInvoiceInput>) => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (updateInvoiceInput: UpdateInvoiceInput) =>
            updateInvoice(updateInvoiceInput, sessionContext?.sessionId ?? null),
        ...options
    });
};
